import {getheaders} from "./authService";

export async function getPropertyJobs(propertyId, startDate, endDate, jobType) {
    let requestOptions = {
        method: 'GET', 
        headers: getheaders(), 
        redirect: 'follow'
    };
    return fetch(`/api/jobs?start_date=${toDateString(startDate)}&end_date=${toDateString(endDate)}&property_id=${propertyId}${jobType ? `&job_type=${encodeURIComponent(jobType)}` : ''}`, requestOptions);
}

export async function getAllJobs(startDate, endDate) {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/goapi/jobs/all?start_date=" + toDateString(startDate) + "&end_date=" + toDateString(endDate), requestOptions)
}

export async function getLostProperties(startDate, endDate) {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/goapi/lost-properties?start_date=" + toDateString(startDate) + "&end_date=" + toDateString(endDate), requestOptions)
}

function appendRegions(url, regions = []) {
    const values = regions.filter(Boolean);
    return values.length ? `${url}${url.includes("?") ? "&" : "?"}regions=${encodeURIComponent(values.join(","))}` : url;
}

export async function getAllJobsString(startDate, endDate, regions = []) {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch(appendRegions("/goapi/jobs/all?start_date=" + startDate + "&end_date=" + endDate, regions), requestOptions)
}

export async function getTaskBoardJobs(regions = []) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch(appendRegions("/goapi/tasks/board", regions), requestOptions)
}

export async function getJobDetails(cosjobid) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/jobs/" + cosjobid, requestOptions)
}

export async function getJobTimeline(jobId, cursor = null, limit = 50) {
    const params = new URLSearchParams({limit: String(limit)});
    if (cursor) {
        params.set('cursor', cursor);
    }
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow',
    };
    return fetch(`/api/job/${jobId}/timeline?${params.toString()}`, requestOptions);
}

export async function addJobTimelineComment(jobId, comment) {
    let requestOptions = {
        method: 'POST', headers: getheaders(), redirect: 'follow',
        body: JSON.stringify({
            comment,
        }),
    };
    return fetch(`/api/job/${jobId}/timeline/comments`, requestOptions);
}

export async function updateJobAdmin(jobDetails) {
    let reqbody = {
        ...jobDetails
    }
    if (reqbody.check_in != null && reqbody.check_in.length === 0) {

        reqbody.check_in = null;
    }
    reqbody.job_id = null
    let requestOptions = {
        method: 'PUT', headers: getheaders(), redirect: 'follow',
        body: JSON.stringify(reqbody)
    };
    return fetch("/api/jobs/admin", requestOptions)
}

export async function createJob(jobDetails) {
    let requestOptions = {
        method: 'POST', headers: getheaders(), redirect: 'follow',
        body: JSON.stringify(jobDetails)
    };
    return fetch("/api/jobs", requestOptions)
}

export async function assignJobWorker(jobId, workerId, acknowledgeRevision) {
    let reqbody = {
        "cos_job_worker": workerId || null, "cos_job_id": jobId,
        ...(workerId && acknowledgeRevision != null ? {acknowledge_important_revision: acknowledgeRevision} : {}),
    }
    let requestOptions = {
        method: 'PUT', headers: getheaders(), redirect: 'follow', body: JSON.stringify(reqbody)
    };
    return fetch("/api/jobs/assign/worker", requestOptions)
}

export async function acknowledgeJobImportant(jobId, revision) {
    return fetch(`/api/jobs/${encodeURIComponent(jobId)}/important/acknowledge`, {
        method: 'POST', headers: getheaders(), body: JSON.stringify({important_revision: revision}),
    });
}

export async function assignJobSupervisor(jobId, supervisorId) {
    let reqbody = {
        "cos_job_supervisor": supervisorId, "cos_job_id": jobId,
    }
    let requestOptions = {
        method: 'PUT', headers: getheaders(), redirect: 'follow', body: JSON.stringify(reqbody)
    };
    return fetch("/api/jobs/assign/supervisor", requestOptions)
}


export function toDateString(inputDate) {
    if (typeof inputDate === "string" && /^\d{4}-\d{2}-\d{2}$/.test(inputDate)) {
        return inputDate;
    }
    const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
    const validDate = Number.isNaN(date.getTime()) ? new Date() : date;
    const year = validDate.getFullYear();
    const month = String(validDate.getMonth() + 1).padStart(2, "0");
    const day = String(validDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}


export async function createOrUpdateParkingFee(payload) {
    let httpMethod = "POST";
    if (payload.id) {
        httpMethod = "PUT";
    }
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch("/api/parkingfee", requestOptions)
}

export async function getAllJobCount(payload) {
    let httpMethod = "POST";
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch("/api/summary/count", requestOptions)
}

export async function getParkingFee(cosJobId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/parkingfee/" + cosJobId, requestOptions)
}

export async function getCheckList(cosJobId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/checklist/" + cosJobId, requestOptions)
}

export async function createOrUpdateExtraCleaningFee(payload) {
    let httpMethod = "POST";
    if (payload.id) {
        httpMethod = "PUT";
    }
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch("/api/extracleaningfee", requestOptions)
}

export async function getExtraCleaningFee(cosJobId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/extracleaningfee/" + cosJobId, requestOptions)
}

export async function toggleChecklistItem(itemId) {
    let requestOptions = {
        method: 'PUT', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/jobs/checklist-items/" + itemId + "/toggle", requestOptions)
}

export async function deleteExtraCleaningFee(cosJobId) {
    let requestOptions = {
        method: 'DELETE', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/extracleaningfee/" + cosJobId, requestOptions)
}
